import { useState, useEffect, useCallback } from "react";
import { getNotifications } from "./notificationService";

export const useUnreadCount = (userId) => {
  const [notifications, setNotifications] = useState(() =>
    getNotifications(userId)
  );

  const updateNotifications = useCallback(() => {
    const newNotifications = getNotifications(userId);

    if (JSON.stringify(newNotifications) !== JSON.stringify(notifications)) {
      setNotifications(newNotifications);
    }
  }, [userId, notifications]);

  useEffect(() => {
    updateNotifications();
    const intervalId = setInterval(updateNotifications, 1000);

    return () => clearInterval(intervalId);
  }, [updateNotifications]);

  const unreadCount = notifications.filter((n) => !n.read).length;
  return { notifications, unreadCount };
};
